export type EventType =
  | "connect"
  | "disconnect"
  | "live_realtime"
  | "live_transcription"
  | "live_turn_complete"
  | "live_interrupted"
  | "live_session_ended"
  | "live_session_timer"
  | "live_ping"
  | "live_pong"
  | "error"
  | "dom_action_call"
  | "dom_action_result"
  | "page_context_call"
  | "page_context_result";

export type DomActionVerb = "click" | "fill" | "select" | "read_text" | "navigate";

export interface DomActionCallPayload {
  call_id: string;
  selector: string;
  action: DomActionVerb;
  value?: string | null;
}

export interface DomActionResultPayload {
  call_id: string;
  success: boolean;
  value?: string | null;
  error?: string | null;
}

export interface PageContextCallPayload {
  call_id: string;
}

export interface PageContextResultPayload {
  call_id: string;
  path: string;
  title: string;
  visible_text: string;
}

export interface ConnectPayload {
  agent_id: string;
  debug?: boolean;
  token: string;
}

export interface LiveRealtimePayload {
  channel: "audio" | "video" | "text";
  mime_type?: string;
  data_b64?: string;
  text?: string;
  audio_stream_end?: boolean;
}

export interface OutgoingEnvelope<P> {
  event: EventType;
  stream_sid: string;
  conversation_id: string;
  payload: P;
}

export interface LiveTranscriptionOut {
  role: "user" | "model";
  text: string;
}

export interface LiveSessionTimerOut {
  remaining_seconds: number;
  total_seconds: number;
}

export type IncomingMessage =
  | { event: "live_realtime"; stream_sid: string; payload: LiveRealtimePayload }
  | {
      event: "live_transcription";
      stream_sid: string;
      live_transcription: LiveTranscriptionOut;
    }
  | { event: "live_turn_complete"; stream_sid: string }
  | { event: "live_interrupted"; stream_sid: string }
  | { event: "live_session_ended"; stream_sid: string }
  | {
      event: "live_session_timer";
      stream_sid: string;
      live_session_timer: LiveSessionTimerOut;
    }
  | { event: "live_ping"; stream_sid: string }
  | { event: "error"; stream_sid: string; message: string }
  | {
      event: "dom_action_call";
      stream_sid: string;
      dom_action_call: DomActionCallPayload;
    }
  | {
      event: "page_context_call";
      stream_sid: string;
      page_context_call: PageContextCallPayload;
    };

export const LIVE_INPUT_SAMPLE_RATE = 16000;
export const LIVE_OUTPUT_SAMPLE_RATE = 24000;
export const LIVE_INPUT_MIME = `audio/pcm;rate=${LIVE_INPUT_SAMPLE_RATE}`;
